import * as React from "react";
import { BaseSVG } from "../../BaseSVG";

export const LeftHandMode = props => (
  <BaseSVG viewBox="0 0 24 24" {...props}>
    <g>
      <path d="M10.5,9.24 C9.29,8.43 8.5,7.06 8.5,5.5 C8.5,3.01 10.51,1 13,1 C15.49,1 17.5,3.01 17.5,5.5 C17.5,7.06 16.71,8.43 15.5,9.24 L15.5,5.5 C15.5,4.12 14.38,3 13,3 C11.62,3 10.5,4.12 10.5,5.5 L10.5,9.24 Z M10.2,11.61 C10.37,11.54 10.55,11.5 10.74,11.5 L11.5,11.5 L11.5,5.5 C11.5,4.67 12.17,4 13,4 C13.83,4 14.5,4.67 14.5,5.5 L14.5,16.24 L17.93,15.52 C18.01,15.51 18.08,15.49 18.17,15.49 C18.48,15.49 18.76,15.62 18.96,15.82 L19.75,16.62 L14.81,21.56 C14.54,21.83 14.16,22 13.75,22 L6.96,22 C6.21,22 5.63,21.45 5.52,20.72 L4.77,15.45 C4.76,15.38 4.75,15.31 4.75,15.25 C4.75,14.63 5.13,14.09 5.66,13.87 L10.2,11.61 Z" />
    </g>
  </BaseSVG>
);
